import { unparse } from "papaparse";
import { call } from "redux-saga/effects";
import { dependencies } from "../dependencies";
import { exportDataToXLSX } from "../utils/xlsx";

export type Table<ColumnHeader = {}, Row = {}> = Array<ColumnHeader[] | Row>;

export function* exportDataAsCSV(resultData: Table) {
  const resultString = unparse(resultData);
  const resultBlob = new Blob([resultString], { type: "text/csv" });

  const { window, saltcomplianceUsersExportFilename } = dependencies;
  const a = yield call([window.document, window.document.createElement], "a");
  yield call([window.document.body, window.document.body.appendChild], a);
  const url = yield call([URL, URL.createObjectURL], resultBlob);
  a.href = url;
  a.download = saltcomplianceUsersExportFilename;
  yield call([a, a.click]);
  yield call(
    () =>
      new Promise(res => {
        setTimeout(res, 0);
      })
  );
  yield call([URL, URL.revokeObjectURL], url);
  yield call([window.document.body, window.document.body.removeChild], a);
}

export function* exportDataAsXLSX(resultData: Table, filename: string) {
  const resultAoA = resultData as string[][];
  exportDataToXLSX(resultAoA, filename);
}
